import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
export function SignInPage() {
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState<{
    email?: string;
    password?: string;
  }>({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const validate = () => {
    const errs: {
      email?: string;
      password?: string;
    } = {};
    if (!form.email.trim()) errs.email = 'Email is required';else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = 'Enter a valid email address';
    if (!form.password) errs.password = 'Password is required';else if (form.password.length < 6) errs.password = 'Password must be at least 6 characters';
    return errs;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate('/');
    }, 1200);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name as keyof typeof errors]) setErrors(prev => ({
      ...prev,
      [name]: undefined
    }));
  };
  return <div className="min-h-screen flex flex-col" style={{
    background: '#F5F5F5'
  }} data-id="element-1321">
      {/* Top accent bar */}
      <div className="h-1 w-full" style={{
      background: '#822433'
    }} data-id="element-1322" />

      <div className="flex-1 flex items-center justify-center px-4 py-16" data-id="element-1323">
        <div className="w-full max-w-md" data-id="element-1324">
          {/* Logo */}
          <div className="text-center mb-8" data-id="element-1325">
            <Link to="/" className="inline-flex items-baseline gap-1" data-id="element-1326">
              <span className="font-black text-3xl tracking-tight" style={{
              color: '#822433'
            }} data-id="element-1327">
                AMERITECH
              </span>
              <span className="font-black text-3xl tracking-tight text-black" data-id="element-1328">
                TIRES
              </span>
            </Link>
            <p className="text-sm mt-1" style={{
            color: '#616365'
          }} data-id="element-1329">
              Sign in to your account
            </p>
          </div>

          {/* Card */}
          <div className="bg-white shadow-[0_4px_24px_rgba(0,0,0,0.10)] p-8" data-id="element-1330">
            {/* Red top border */}
            <div className="h-1 w-12 mb-8" style={{
            background: '#822433'
          }} data-id="element-1331" />

            <h1 className="font-black text-2xl text-black mb-1" data-id="element-1332">
              Welcome Back
            </h1>
            <p className="text-sm mb-8" style={{
            color: '#616365'
          }} data-id="element-1333">
              Don't have an account?{' '}
              <Link to="/signin" className="font-semibold transition-colors" style={{
              color: '#822433'
            }} onMouseEnter={e => e.currentTarget.style.color = '#6B1D29'} onMouseLeave={e => e.currentTarget.style.color = '#822433'} data-id="element-1334">
                Create one free
              </Link>
            </p>

            <form onSubmit={handleSubmit} noValidate className="space-y-5" data-id="element-1335">
              {/* Email */}
              <div data-id="element-1336">
                <label htmlFor="email" className="block text-sm font-bold text-black mb-1.5" data-id="element-1337">
                  Email Address
                </label>
                <div className="relative" data-id="element-1338">
                  <MailIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1339" />
                  <input id="email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" className={`w-full pl-10 pr-4 py-3 border text-black text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#822433] focus:border-transparent transition-colors ${errors.email ? 'border-red-400 bg-red-50' : 'border-gray-200'}`} autoComplete="email" data-id="element-1340" />
                </div>
                {errors.email && <p className="mt-1 text-xs text-red-500" data-id="element-1341">{errors.email}</p>}
              </div>

              {/* Password */}
              <div data-id="element-1342">
                <div className="flex items-center justify-between mb-1.5" data-id="element-1343">
                  <label htmlFor="password" className="block text-sm font-bold text-black" data-id="element-1344">
                    Password
                  </label>
                  <a href="#" className="text-xs font-semibold transition-colors" style={{
                  color: '#822433'
                }} onMouseEnter={e => e.currentTarget.style.color = '#6B1D29'} onMouseLeave={e => e.currentTarget.style.color = '#822433'} data-id="element-1345">
                    Forgot password?
                  </a>
                </div>
                <div className="relative" data-id="element-1346">
                  <LockIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1347" />
                  <input id="password" name="password" type={showPassword ? 'text' : 'password'} value={form.password} onChange={handleChange} placeholder="Enter your password" className={`w-full pl-10 pr-10 py-3 border text-black text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#822433] focus:border-transparent transition-colors ${errors.password ? 'border-red-400 bg-red-50' : 'border-gray-200'}`} autoComplete="current-password" data-id="element-1348" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" aria-label={showPassword ? 'Hide password' : 'Show password'} data-id="element-1349">
                    {showPassword ? <EyeOffIcon size={16} data-id="element-1350" /> : <EyeIcon size={16} data-id="element-1351" />}
                  </button>
                </div>
                {errors.password && <p className="mt-1 text-xs text-red-500" data-id="element-1352">{errors.password}</p>}
              </div>

              {/* Submit */}
              <button type="submit" disabled={loading} className="w-full text-white font-black text-sm uppercase tracking-widest py-4 transition-colors duration-200 mt-2 flex items-center justify-center gap-2" style={{
              background: loading ? '#AA9C8F' : '#CC0000'
            }} onMouseEnter={e => {
              if (!loading) e.currentTarget.style.background = '#AA0000';
            }} onMouseLeave={e => {
              if (!loading) e.currentTarget.style.background = '#CC0000';
            }} data-id="element-1353">
                {loading ? <>
                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1354">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1355" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" data-id="element-1356" />
                    </svg>
                    Signing In...
                  </> : 'Sign In'}
              </button>
            </form>

            {/* Divider */}
            <div className="flex items-center gap-3 my-6" data-id="element-1357">
              <div className="flex-1 h-px bg-gray-200" data-id="element-1358" />
              <span className="text-xs text-gray-400 font-medium" data-id="element-1359">OR</span>
              <div className="flex-1 h-px bg-gray-200" data-id="element-1360" />
            </div>

            {/* Guest CTA */}
            <Link to="/contact" className="w-full flex items-center justify-center font-bold text-sm py-3 border-2 transition-colors duration-200" style={{
            borderColor: '#CC0000',
            color: '#CC0000'
          }} onMouseEnter={e => {
            e.currentTarget.style.background = '#CC0000';
            e.currentTarget.style.color = '#fff';
          }} onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = '#CC0000';
          }} data-id="element-1361">
              Book a Service Without an Account
            </Link>
          </div>

          {/* Footer note */}
          <p className="text-center text-xs mt-6" style={{
          color: '#616365'
        }} data-id="element-1362">
            By signing in, you agree to our{' '}
            <a href="#" className="underline hover:text-black transition-colors" data-id="element-1363">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="#" className="underline hover:text-black transition-colors" data-id="element-1364">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>;
}